import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { GroupRestrictionDialogComponent } from './group-restriction-dialog.component';



@NgModule({
  declarations: [
    GroupRestrictionDialogComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    SharedModule
  ],
  exports: [
    GroupRestrictionDialogComponent
  ],
  entryComponents: [
    GroupRestrictionDialogComponent
  ]
})
export class GroupRestrictionDialogModule { }
